import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxEzModalService } from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import { Roles } from '../../../../../../shared/modules/core/services/roles.service';

@Component({
  selector: 'app-position-select',
  templateUrl: './position-select.component.html',
  styleUrls: ['./position-select.component.scss']
})
export class PositionSelectComponent {
  @Input() lang: string;
  @Input() type: string;

  @Output() selectedData = new EventEmitter<any>();
  @Output() closed = new EventEmitter<boolean>();


  roles: string[] = [];
  gameColor: any = {
    lol: 'gold',
    'wild-rift': 'blue',
    valorant: 'red',
    apex: 'red',
    marvel: 'yellow',
  }

  keySet = 1;
  selectedPrimaryRole: string = '';
  selectedSecondaryRole: string = '';
  game: string = '';

  constructor(
    public modalService: NgxEzModalService
  ) { }

  ngOnInit() {
    this.roles = Roles[this.game];
  }

  onSelect() {
    this.selectedData.emit({ selectedPrimaryRole: this.selectedPrimaryRole, selectedSecondaryRole: this.selectedSecondaryRole, keySet: this.keySet });
    this.modalService.closeOutletModals('rolesCustomization');
  }

  toggleRole(type: 'primary' | 'secondary', role: string) {
    if (type === 'primary') {
      if (this.selectedSecondaryRole === role) {
        this.selectedSecondaryRole = this.selectedPrimaryRole;
      }
      this.selectedPrimaryRole = role;
    }
    if (type === 'secondary') {
      if (this.selectedPrimaryRole === role) {
        this.selectedPrimaryRole = this.selectedSecondaryRole;
      }
      this.selectedSecondaryRole = role;
    }
  }

  closeWithoutSelectedData() {
    this.modalService.closeOutletModals('rolesCustomization');
  }

  getImageUrl(role: string, color: string): string {
    return `https://cdn.ggboost.com/images/${this.game}/icons/roles/${role}_${color}.png`;
  }
}